exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".market-recommend{width:100%;background-color:#f7f7f7;margin:30px 0;padding:20px}.market-recommend h3{font-weight:400;font-family:NanumBarunGothicOTF;font-size:26px}.market-recommend ul{width:100%;list-style:none;display:flex;overflow-x:scroll;padding:30px 0}.market-recommend ul:not(:last-child){margin-bottom:20px}.market-recommend ul::-webkit-scrollbar{display:unset;width:10px}.market-recommend ul::-webkit-scrollbar-track{background:#f1f1f1;border-radius:10px}.market-recommend ul::-webkit-scrollbar-thumb{background:#888;border-radius:10px}.market-recommend ul::-webkit-scrollbar-thumb:hover{background:#555}.market-recommend li:not(:last-child){margin-right:10px}.market-recommend img{width:448px;height:290px;object-fit:fill;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28c9b6f6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MarketManager/Market/Recommend.vue
// module id = 172
// module chunks = 0